import React from 'react';
import { Routes, Route } from "react-router-dom";

import NavigationBar from './components/Navbar';
import Footer from './components/Footer';
import CanonicalTag from './components/CanonicalTag';

import Home from './components/Home';
import About from './components/About';
import Hero from './components/Hero';

import CementRawMaterials from './components/CementRawMaterials';
import Rawmill from './components/Rawmill';
import CementProduction from './components/CementProduction';
import CementEquipments from './components/CementEquipments';
import Cement from './components/Cement';
import Download from './components/Download-brochure';
import CoporateGovernance from "./components/CoporateGovernance";
import WhyUs from './components/Whyus';
import Contact from './components/Contact';
import ScrollToTop from './components/ScrollToTop';

import 'animate.css';
import 'bootstrap-icons/font/bootstrap-icons.css';

function App() {
  return (
    <div>
      <ScrollToTop/> 
      <NavigationBar />
      <CanonicalTag />

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/hero" element={<Hero />} />
        <Route path="/about" element={<About />} />
        <Route path="/products/cement-raw-materials" element={<CementRawMaterials />} />
        <Route path="/products/raw-mill" element={<Rawmill />} />
        <Route path="/products/cement-production" element={<CementProduction />} />
        <Route path="/products/cement-equipments" element={<CementEquipments />} />
        <Route path="/cement" element={<Cement />} />
        <Route path="/download-brochure" element={<Download />} />
        <Route path='/coporate-governance' element={<CoporateGovernance />}/>
        <Route path="/why-us" element={<WhyUs />} />
        <Route path="/contact" element={<Contact />} />

        
      </Routes>

      <Footer />
    </div>
  );
}

export default App;
